import { DOCUMENT } from '@angular/common';
import { InjectionToken } from '@angular/core';

import { AuthProvider } from '®shared/auth/auth-provider';
import { AuthServiceLogin } from '®shared/auth/auth-service-login';
import { PersonaPkceAuthService } from '®shared/auth/persona-pkce-auth.service';
import { PersonaPkceLtiAuthService } from '®shared/auth/persona-pkce-lti-auth.service';
import { User } from '®shared/auth/user';
import { AppConfig } from '®shared/config';

import { PersonaPadlockService } from './persona-padlock.service';
import { PersonaPkceBreakoutAuthService } from './persona-pkce-breakout-auth.service';

const authenticatedAuthServiceFactory = (
  document: Document,
  appConfig: AppConfig,
  personaPadlockService: PersonaPadlockService,
  pkceAuthService: PersonaPkceAuthService,
  pkceBreakoutAuthService: PersonaPkceBreakoutAuthService,
  pkceLtiAuthService: PersonaPkceLtiAuthService,
): AuthProvider<User> & AuthServiceLogin => {
  const url = new URL(document.location.href);
  const isInPkceLti1p3Context = url.searchParams.has('lti_auth_nonce');

  if (isInPkceLti1p3Context || appConfig.isAnLti1p0EmbeddedSession) {
    return pkceLtiAuthService;
  } else if (!personaPadlockService.isFirstPartyContext()) {
    return pkceBreakoutAuthService;
  } else {
    return pkceAuthService;
  }
};

export const AUTHENTICATED_AUTH_SERVICE = new InjectionToken<
  AuthProvider<User> & AuthServiceLogin
>('app.context.authenticatedAuthService');

export const authenticatedAuthServiceProvider = {
  provide: AUTHENTICATED_AUTH_SERVICE,
  useFactory: authenticatedAuthServiceFactory,
  deps: [
    DOCUMENT,
    AppConfig,
    PersonaPadlockService,
    PersonaPkceAuthService,
    PersonaPkceBreakoutAuthService,
    PersonaPkceLtiAuthService,
  ],
};
